<template>
  <div>
    <b-navbar id="header" type="light" variant="light" sticky>
      <b-navbar-nav class="mr-2">
        <b-button size="sm" variant="primary" @click="onBack()">
          <font-awesome-icon icon="chevron-left"/>
          Назад
        </b-button>
      </b-navbar-nav>
      <b-navbar-nav class="mx-2">
        <h4 class="mb-0">{{title}}</h4>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-row align-v="center">
          <b-col cols="auto">
            <b-button size="sm" variant="success" :disabled="loading" @click="handleSubmit()">
              <b-spinner v-if="loading" small></b-spinner>
              Сохранить
            </b-button>
          </b-col>
        </b-row>
      </b-navbar-nav>
    </b-navbar>

    <b-card no-body>
      <b-form @submit.stop.prevent="handleSubmit">
        <b-container fluid class="my-2">
          <b-row>
            <b-col>
              <b-card bg-variant="light">
                <b-row>
                  <b-col lg="2" md="4">
                    <b-form-group label="Период">
                      <month-picker
                        v-model="newItem.period"
                        placeholder="Выберите период"
                        :min-year="2025"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col lg="2" md="4">
                    <b-form-group
                      id="group-accrual-date"
                      label="Дата"
                      label-for="input-accrual-date"
                    >
                      <b-form-input
                        id="input-accrual-date"
                        size="sm"
                        type="date"
                        v-model.date="newItem.accrued_date"/>
                    </b-form-group>
                  </b-col>

                  <b-col lg="3" md="4">
                    <b-form-group
                      id="group-accrual-organization"
                      label="Организация"
                      label-for="input-organization-select"
                    >
                      <organization-select
                        id="input-organization-select"
                        ref="organization_select"
                        class="mb-1 mr-2"
                        v-bind:initial-id="newItem.organization_id"
                        v-on:onSelect="onSelectOrganization"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="2" md="4">
                    <b-form-group
                      id="group-accrual-code"
                      label="Номер"
                      label-for="input-accrual-code"
                    >
                      <b-form-input
                        id="input-salary-code"
                        type="text"
                        size="sm"
                        v-model="newItem.code"
                        trim />
                    </b-form-group>
                  </b-col>

                  <b-col lg="3" md="4">
                    <b-form-group
                      id="group-accrual-comment"
                      label="Комментарий"
                      label-for="input-accrual-comment"
                    >
                      <b-form-input
                        id="input-accrual-comment"
                        type="text"
                        size="sm"
                        v-model="newItem.comment"
                        trim />
                    </b-form-group>
                  </b-col>
                  <!--Требует доработки нигде не используется Временно убрали чтобы не путать при показе -->
                  <b-col lg="2" md="4" v-if="false">
                    <b-form-group
                      id="group-accrual-pay-with"
                      label="Оплачивать с"
                      label-for="input-accrual-pay-with"
                    >
                      <b-form-select
                        id="input-accrual-type"
                        size="sm"
                        v-model="newItem.pay_with_id"
                      >
                        <option v-for="option in payWithTypes" :value="option.id">
                          {{ option.name }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-checkbox v-model="newItem.active" size="md">Активен / не активен</b-form-checkbox>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
            <b-col cols="3">
              <b-card no-body bg-variant="light">
                <b-card-header>
                  <h6 id="task-header">Итого</h6>
                </b-card-header>
                <b-list-group flush bg-variant="light">
                  <b-list-group-item bg-variant="light" class="d-flex justify-content-between align-items-center">
                    Начислено
                    <strong>{{priceFormat(totalAmount)}}</strong>
                  </b-list-group-item>
                  <b-list-group-item bg-variant="light" class="d-flex justify-content-between align-items-center">
                    Количество
                    <strong>{{priceFormat(totalQuantity)}}</strong>
                  </b-list-group-item>
                  <b-list-group-item bg-variant="light" class="d-flex justify-content-between align-items-center">
                    НДФЛ
                    <strong>{{priceFormat(totalNdflAmount)}}</strong>
                  </b-list-group-item>
                  <b-list-group-item bg-variant="light" class="d-flex justify-content-between align-items-center">
                    Страховые
                    <strong>{{priceFormat(totalInsuranceAmount)}}</strong>
                  </b-list-group-item>
                  <b-list-group-item bg-variant="light" class="d-flex justify-content-between align-items-center">
                    Пенс. до превыш.
                    <strong>{{priceFormat(totalPensionBeforeAmount)}}</strong>
                  </b-list-group-item>
                  <b-list-group-item bg-variant="light" class="d-flex justify-content-between align-items-center">
                    Пенс. после превыш.
                    <strong>{{priceFormat(totalPensionAfterAmount)}}</strong>
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
          </b-row>
        </b-container>
      </b-form>

      <accrual-staff-list :accrual="newItem" @change="onChangeAccrualStaff"></accrual-staff-list>
    </b-card>
  </div>
</template>

<script>
import accruals from "../../network/accruals";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
    import MonthPicker from "../MonthPicker/MonthPicker";
    import StaffMultiSelect from "../Staff/StaffMultiSelect";
    import AccrualStaffList from "../AccrualStaff/AccrualStaffList";
    import OrganizationSelect from "../Organizations/OrganizationSelect";

const commonErrorMessage = "Что-то пошло не так. Попробуйте обновить страницу и повторить действие.";

export default {
  name: "Accrual",
  components: { AccrualStaffList, MonthPicker, StaffMultiSelect, OrganizationSelect },
  mixins: [
    accruals,
    helpers, dateFormatter
  ],
  data() {
    return {
      title: "Начисление",
      newItem: {
        id: 0,
        period: this.newPeriodDate(),
        accrued_date: this.stringDateToInputFromDate(this.newOnlyDate()),
        organization_id: 0,
        organization_name: '',
        accrual_type_id: null,
        accrual_type_name: '',
        amount_sum: 0,
        quantity_sum: 0,
        ndfl_amount_sum: 0,
        insurance_amount_sum: 0,
        pension_before_amount_sum: 0,
        pension_after_amount_sum: 0,
        code: '',
        status: 'created',
        pay_with_id: null,
        pay_with_name: '',
        comment: '',
        active: true,
        accrual_staffs: []
      },
      isBusy: false,
      loading: false,
      accrualTypes: [],
      payWithTypes: [],
    }
  },
  async created() {
    this.accrualTypes = this.getAccrualTypes();
    this.payWithTypes = this.getPayWithTypes();
    await this.updateView();
  },
  computed: {
    totalAmount() {
      const result = this.newItem.accrual_staffs
        .map(obj => obj.amount)
        .reduce((acc, current) => acc + current, 0);

      return Math.round(result * 100) / 100;
    },
    totalQuantity() {
      const result = this.newItem.accrual_staffs
        .map(obj => obj.quantity)
        .reduce((acc, current) => acc + current, 0);

      return Math.round(result * 100) / 100;
    },
    totalNdflAmount() {
      const result = this.newItem.accrual_staffs
        .map(obj => obj.ndfl_amount)
        .reduce((acc, current) => acc + current, 0);

      return Math.round(result * 100) / 100;
    },
    totalInsuranceAmount() {
      const result = this.newItem.accrual_staffs
        .map(obj => obj.insurance_amount)
        .reduce((acc, current) => acc + current, 0);

      return Math.round(result * 100) / 100;
    },
    totalPensionBeforeAmount() {
      const result = this.newItem.accrual_staffs
        .map(obj => obj.pension_before_amount)
        .reduce((acc, current) => acc + current, 0);

      return Math.round(result * 100) / 100;
    },
    totalPensionAfterAmount() {
      const result = this.newItem.accrual_staffs
        .map(obj => obj.pension_after_amount)
        .reduce((acc, current) => acc + current, 0);

      return Math.round(result * 100) / 100;
    },
  },
  methods: {
    async updateView() {
      const id = this.$route.params.id;
      if (id) {
        await this.getItem(id);
      }

      let typeId = this.$route.params.type_id;
      if (typeId) {
        this.newItem.accrual_type_id = typeId;
      } else {
        typeId = this.newItem.accrual_type_id;
      }

      const accrualType = this.accrualTypes.find(x => x.id === typeId);
      if (accrualType != null) {
        this.title = `${accrualType.title}`;
      }
    },
    async getItem(id) {
      this.isBusy = true;
      const result = await this.getAccrualById(id);
      if (result.data == null) {
        this.showError(commonErrorMessage);
        return;
      }

      this.newItem = result.data;

      this.newItem.period = this.dateFromServerString(this.newItem.period);

      const accruedDate = this.dateFromServerString(this.newItem.accrued_date);
      this.newItem.accrued_date = this.stringDateToInputFromDate(accruedDate);

      if (this.$refs.organization_select != null) {
        await this.$refs.organization_select.configure(this.newItem.organization_id);
      }
    },
    onBack() {
      this.goBack();
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        const path = '/accruals';
        this.$router.push(path).catch(()=>{});
      }
    },
    formattedFromServerDate(date) {
      if (date != null) {
        date = this.formatDate(this.getDateFromServerString(date));
      }
      return date;
    },
    formattedToServerDate(date) {
      if (!this.isDateValid(date)) {
        return null;
      }

      if (date != null) {
        date = this.localISOString(this.getDateToServer(date));
      }

      return date;
    },
    async handleSubmit() {
      if (this.newItem.accrued_date == null) {
        this.showError("Укажите Дату");
        return;
      }

      if (this.newItem.organization_id === 0) {
        this.showError("Выберите организацию");
        return;
      }

      if (this.newItem.accrual_type_id === 0) {
        this.showError("Выберите тип начисления");
        return;
      }

      this.newItem.amount_sum = this.totalAmount;
      this.newItem.quantity_sum = this.totalQuantity;
      this.newItem.ndfl_amount_sum = this.totalNdflAmount;
      this.newItem.insurance_amount_sum = this.totalInsuranceAmount;
      this.newItem.pension_before_amount_sum = this.totalPensionBeforeAmount;
      this.newItem.pension_after_amount_sum = this.totalPensionAfterAmount;

      const data = Object.assign({}, this.newItem);

      data.period = this.stringDateToServerFromDate(this.newItem.period);
      data.accrued_date = this.stringDateToServerFormString(data.accrued_date);

      const accrualType = this.accrualTypes.find(x => x.id === data.accrual_type_id);
      if (accrualType != null) {
        data.accrual_type_name = accrualType.name;
      }

      const payWithType = this.payWithTypes.find(x => x.id === data.pay_with_id);
      if (payWithType != null) {
        data.pay_with_name = payWithType.name;
      }

      if (data.id > 0) {
        const result = await this.putAccrual(data);
        if (result.data == null) {
          this.showError(commonErrorMessage);
          return;
        }
        this.newItem.id = result.data.id;
        this.onBack();
      } else {
        const result = await this.postAccrual(data);
        if (result.data == null) {
          this.showError(commonErrorMessage);
          return;
        }
        this.newItem.id = result.data.id;
        this.onBack();
      }
    },
    onSelectOrganization(id) {
      this.newItem.organization_id = id;
      if (this.$refs.organization_select != null) {
        this.newItem.organization_name = this.$refs.organization_select.item.name;
      }
    },
    onChangeAccrualStaff(items) {
      this.newItem.accrual_staffs = items;
    },

    getAccrualTypes() {
      return [
        {
          id: 1,
          name: 'Аванс',
          title: 'Начисление Аванса',
        },
        {
          id: 2,
          name: 'Зарплата',
          title: 'Начисление Зарплаты',
        },
        {
          id: 3,
          name: 'Отпуск',
          title: 'Начисление Отпуска',
        },
        {
          id: 4,
          name: 'Премия',
          title: 'Начисление Премии',
        },
        {
          id: 5,
          name: 'Аванс Сдельно',
          title: 'Начисление Аванса Сдельно',
        },
        {
          id: 6,
          name: 'Зарплата Сдельно',
          title: 'Начисление Зарплаты Сдельно',
        },
        {
          id: 7,
          name: 'Премия Сдельно',
          title: 'Начисление Премии Сдельно',
        },
      ]
    },
    getPayWithTypes() {
      return [
        {
          id: 1,
          name: 'Аванс'
        },
        {
          id: 2,
          name: 'Межрасчетный период'
        },
        {
          id: 3,
          name: 'Зарплата'
        },
      ]
    }
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Accruals/Accrual.vue